<template>
  <div>
    <div class="content">
      <div class="pending" v-if="pending">
        <el-alert type="info" :closable="false" :show-icon="false">
          <span slot="title">
            请单位用户账号的使用人，使用本人的
            <span class="color-primary">“交管12123”APP进行扫码</span>
            ，登录后将立即开始同步。</span>
        </el-alert>
        <div class="qrcode" v-loading="loading">
          <img :src="qrCode" v-if="qrCode"/>
          <div class="mask" v-if="tips"></div>
          <div class="tip" @click="refresh" v-if="tips">
            <i class="el-icon-refresh">{{ tips }}</i>
          </div>
        </div>
      </div>
      <div class="login-success" v-else>
        <div class="title"><i class="el-icon-success success"></i>扫码登录成功</div>
        <p>查询进行中，根据车辆数量可能需要半小时左右，请您耐心等待。</p>
        <p>请返回列表，刷新页面查看查询结果状态，以确认是否执行完成。</p>
      </div>
    </div>
    <div class="only-contract-tip" v-if="showOnlyContractTip">
      本次扫码仅对发生状态变更的订单进行备案同步，不针对所有订单执行状态查询及更新操作，也不做违章信息更新操作。
    </div>
    <div class="footer">
      <el-button @click="close">返回</el-button>
    </div>
  </div>
</template>
<script>
import { getLoginQrCode, queryQrCodeStatus } from '@/api/domain/carsService'

export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    operateTypes: {
      type: Array,
      default: () => [],
    },
    contractNo: {
      type: String,
      default: '',
    },
    companyCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pending: true, // 是否在等待扫码登录（二维码界面）
      tips: '', // 二维码失效、获取失败、登录失败等情况时的提示信息
      timer: null, // 客户端兜底超时计时器，防止服务端中途不可用时客户端一直轮询
      startTime: 0, // 客户端计时开始时间
      flowId: '', // 查询二维码状态的token
      qrCode: '', // 二维码base64码
      loading: false, // 正在获取二维码
    }
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (!val) {
          this.close() // 关闭弹窗时重置页面状态
        } else {
          this.refresh() // 打开弹窗时刷新二维码
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @private
     * 重置页面状态
     */
    reset() {
      this.pending = true
      this.tips = ''
      this.qrCode = ''
      this.flowId = ''
      this.startTime = 0
      clearTimeout(this.timer)
      this.loading = false
    },
    /**
     * @private
     * 重置页面状态, 并重新请求二维码
     */
    async refresh() {
      this.reset() // 重置页面状态

      try {
        this.loading = true
        const res = await getLoginQrCode({
          operateTypes: this.operateTypes,
          contractNo: this.contractNo,
          companyCode: this.companyCode,
        }) // 获取二维码

        if (res && res.code === 1) {
          this.qrCode = `data:image/png;base64,${res.data.img}`
          this.flowId = res.data.flowId

          this.poolServer() // 轮询入口可不必await
        }
      } finally {
        this.loading = false
        if (!this.qrCode) this.tips = '获取二维码失败，请重试'
      }
    },
    /**
     * @private
     * 轮询二维码状态
     * 每1.5秒轮询一次，直到登录成功或服务端二维码过期，期间任何服务异常不处理（例如网络抖动、服务临时不可用），不打断轮询，靠客户端5分钟超时兜底
     */
    async poolServer() {
      // 如果弹窗已经关闭，不再轮询，例如生成二维码期间用户关闭弹窗
      if (!this.dialogVisible) {
        return
      }
      // 如果已经登录成功，不再轮询
      if (!this.pending) {
        return
      }

      clearTimeout(this.timer) // double check, 防止多次触发
      const timeout = () => { this.tips = '二维码已失效' } // 二维码过期

      // 1. 客户端5分钟超时判断
      if (this.startTime) {
        const threshold = 300000 + 5000 // 5分钟+5秒误差，防止服务端未超时，客户端误判断超时
        if (Date.now() - this.startTime > threshold) {
          return timeout()
        }
      } else {
        this.startTime = Date.now() // 开始客户端计时
      }

      // 2. 查询二维码状态，只关注登录成功和二维码过期，其他状态和请求异常一概忽略，catch且不处理
      try {
        const { code } = await queryQrCodeStatus({ flowId: this.flowId })
        if (code === 1) {
          this.pending = false
          this.startTime = 0 // 结束客户端计时
          return
        }
      } catch (e) {
        if (e.code === 75100) { // 二维码过期
          return timeout()
        }
      }

      // 3. 轮询
      this.timer = setTimeout(async () => {
        await this.poolServer()
      }, 1500)
    },
    /**
     * @private
     * 通知父容器关闭弹窗
     */
    close() {
      this.$emit('cancelDialog', !this.pending) // 通知父容器关闭弹窗并根据登录状态刷新列表
      this.reset() // 重置页面状态，重置定时器
    },
  },
  computed: {
    showOnlyContractTip() {
      return this.operateTypes.includes('5')
    },
  },
}
</script>
<style scoped>
.color-primary {
  color: #276BEC;
}
.pending {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qrcode {
  position: relative;
  width: 270px;
  height: 270px;
  display: flex;
  justify-content: center;
  align-items: center;

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: #fff;
    opacity: .9;
    filter: Alpha(opacity = 90);
  }

  .tip {
    position: absolute;
    top: 50%;
    width: 100%;
    text-align: center;
    cursor: pointer;

    &:hover {
      color: #276BEC;
    }
  }
}

.login-success {
  width: 100%;
  height: 100%;
  text-align: center;

  .title {
    font-size: 24px;
    font-weight: bold;
    margin: 24px 0 40px;
  }

  i {
    margin-right: 10px;
  }

  p {
    margin-bottom: 30px;
  }
}

.only-contract-tip {
  color: red;
  text-align: left;
  margin: 20px 30px;
}

.footer {
  text-align: center;
  margin: 40px 0 10px;
}
</style>
